module.exports = __webpack_public_path__ + "static/media/BA.e2be9a78.png";